<template>
  <div>
    <div class="popup_wrap connect_protocol" v-if="visible">
      <div class="popup_title">
        <p><span id="node_title">프로토콜 연결
        </span></p>
        <a>
          <div id="popup_close" class="btn_close" title="Close" @click="close">
            <div class="btn_close_box"><span></span><span></span></div>
          </div>
        </a>
      </div><!-- //popup_title -->
      <div class="popup_content">
        <div class="tbl_wrap">
          <table class="tbl_style2">
            <colgroup>
              <col style="width: 10%;">
              <col style="width: 55%;">
              <col style="width: 10%;">
              <col style="width: 10%;">
              <col style="width: 15%;">
            </colgroup>
            <thead>
            <tr>
              <th></th>
              <th>프로토콜명</th>
              <th>작성자</th>
              <th>연결자</th>
              <th>연결일자</th>
            </tr>
            </thead>
            <tbody v-if="connectedProtocolList && connectedProtocolList.length > 0">
            <tr class="border-bottom cursor-pointer"
                v-for="(connectedProtocol, index) in connectedProtocolList"
                :key="index"
                @click="callProtocolDetail(connectedProtocol.protocolId)"
                :style="{ 'background-color: aliceblue' : connectedProtocol.checked}">
              <td class="py-1 text-center border-right" @click.stop="">
                <input type="checkbox"
                       v-model="connectedProtocol.checked"
                       :value="connectedProtocol.protocolId"
                >
              </td>
              <td class="py-1 text-center border-right">
                <span>
                  <p v-html="connectedProtocol.name"></p>
                </span>
              </td>
              <td class="py-1 text-center border-right">{{connectedProtocol.userName}}</td>
              <td class="py-1 text-center border-right">{{connectedProtocol.connectedUserName}}</td>
              <td class="py-1 text-center border-right">
                <div>{{connectedProtocol.connectedDate | timeFilter}}</div>
              </td>
            </tr>
            </tbody>
            <tbody v-else>
            <tr>
              <td colspan="5">
                <div class="nodata_txt">
                  <p>연결된 프로토콜이 존재하지 않습니다.
                  </p>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="popup_footer">
        <a class="btn_type2" @click="disconnectProtocol">프로토콜 연결삭제</a>
        <a class="btn_type1" @click="callSearchProtocolPop">프로토콜 검색</a>
        <a class="btn_type3" @click="close">닫기</a>
      </div>
    </div>
    <div class="mask_wrap" style="display:block;" v-if="visible"></div>
    <Loading :visible="loading" type="fixed"/>
  </div>
</template>

<script>
  import Loading from '@common/loading.vue';
  import {createNamespacedHelpers} from 'vuex';

  const Hub = createNamespacedHelpers('Hub');
  const ProcessEditor = createNamespacedHelpers('ProcessEditor');

  export default {
    components: {
      Loading,
    },
    data() {
      return {
        loading: false,
        visible: false,
        connectedProtocolList: [],
        processId: null,
        keyOfProtocol: "",
        maxConnectCount: 1,
      }
    },
    computed: {
      ...Hub.mapGetters(
          [
            'getConnectProtocolObj'
          ]),
      // ProcessEditor 모듈의 Getters
      ...ProcessEditor.mapGetters([
          'getDiagram'
      ]),
      checkIdList() {
        if (this.connectedProtocolList != null && this.connectedProtocolList.length > 0) {
          let checkIdList = new Array();
          this.connectedProtocolList.filter(item => item.checked === true).forEach(item => {
            checkIdList.push(item.innerProtocolId);
          })
          return checkIdList;
        }
      }
    },
    watch: {
      getConnectProtocolObj: {
        deep: true,
        async handler(value) {
          if (value.connectProtocolPopFlag === true && typeof value.connectNodeInfo == 'object') {
            this.show();
          } else if (value.connectProtocolPopFlag === false) {
            this.visible = false;
          }
        }
      },
    },
    async mounted() {
    },
    filters: {
        timeFilter(time) {
          if(time) {
            if (time) time = time.replace('T', ' ');
            else time = '';
            return time
          }else{
            return "-";
          }
        }
    },
    methods: {
      ...Hub.mapMutations(
          [
            'setConnectProtocolObj'
            , 'setSearchProtocolObj'
            , 'setProtocolDetailObj'
          ]
      ),
      async show() {
        await this.init();
      },
      async init(){
        this.resetData(true);
        this.loading = true;
        this.processId = this.$route.query.processId;
        this.keyOfProtocol = this.getConnectProtocolObj.connectNodeInfo.key
        let protocols = await this.$wApi.process.getProtocols(null, this.processId);
        if(protocols == null){
          this.loading = false;
          await window.alert("프로토콜 조회 중 오류가 발생하였습니다.");
          return;
        }
        protocols.filter(protocol => protocol.innerKeyOfProtocol == this.keyOfProtocol).forEach(protocol => {
          let obj = {
            protocolId: protocol.protocolId,
            innerProtocolId: protocol.innerProtocolId,
            createdDate: protocol.createdDate,
            updatedDate: protocol.updatedDate,
            name: protocol.name,
            userName: protocol.user?.userName || "-",
            connectedUserName: protocol.connectedUser?.userName || "-",
            connectedDate: protocol.connectedDate,
            checked: false,
          };
          this.connectedProtocolList.push(obj);
        });
        this.loading = false;
        this.visible = true;
      },
      resetData(visible) {
        if(!visible){
          visible = false;
        }
        this.loading = false;
        this.visible = visible;
        this.connectedProtocolList = [];
        this.processId = null;
        this.keyOfProtocol = "";
        this.maxConnectCount = 1;
      },
      async close() {
        const cnt = await this.checkCount();
        const protocolData = {cnt:cnt};
        const nodeData = this.getDiagram.model.findNodeDataForKey(this.keyOfProtocol);
        if (nodeData) {
          this.getDiagram.model.setDataProperty(nodeData, "protocolData",protocolData);
        }
        this.resetData();
        this.setConnectProtocolObj({
          openFlag: false,
          dataObj: {}
        });
      },
      async callSearchProtocolPop() {
        const protocolConnectedCount=await this.checkCount();
        if(protocolConnectedCount < this.maxConnectCount) {
          this.setSearchProtocolObj({
            openFlag: true,
            dataObj: {
              ...this.getConnectProtocolObj.connectNodeInfo
            }
          });
        }else{
          await window.alert(`현재 프로토콜 연결은 노드당 ${this.maxConnectCount}개만 가능합니다.`);
          return;
        }
      },
      callProtocolDetail(protocolId) {
        let protocolDetailData = {};
        protocolDetailData.protocolId = protocolId;
        protocolDetailData.processId = this.processId;
        protocolDetailData.isPublish = false;
        this.setProtocolDetailObj({
          openFlag: true,
          dataObj: protocolDetailData,
        });
      },
      async checkCount(){
        this.loading = true;
        const connectedProtocols = await this.$wApi.process.getProtocols(null, this.processId);
        this.loading = false;
        if(connectedProtocols && connectedProtocols.length > 0) {
          return connectedProtocols.filter(protocol => protocol.innerKeyOfProtocol == this.keyOfProtocol).length;
        }else{
          return 0;
        }
      },
      async disconnectProtocol() {
        if (!this.checkIdList || this.checkIdList.length == 0) {
          alert("연결을 삭제할 프로토콜을 체크해주세요.");
          return;
        }

        this.loading = true;
        try {
          const confirmResult = await confirm("원본 프로토콜을 삭제되지 않고 연결 정보만 삭제됩니다.<br/> 연결을 삭제하시겠습니까?");
          if (!confirmResult) return;
          let response = await this.$wApi.protocol.disconnectProtocolList({
            disconnectIdList: this.checkIdList
          });
          if (response) {
            this.init();
          }
        } catch (error) {
          this.loading = false;
        } finally {
          this.loading = false;
        }
      },
    }
  }
</script>

<style lang="scss">
  @import "@/style/new/css/cyl.common.css";

  .connect_protocol {
    display: block;
    position: fixed;
    width: 850px;
    height: 50%;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 999;
    box-shadow: 5px 5px 20px 0px rgba(0, 0, 0, 0.2);
  }

  @media screen and (max-width: 950px) {
    .connect_protocol {
      width: 95%;
    }
  }

</style>
